import i18n from '../i18n';
import { axiosApi } from './api';

const clickUpCustomFields = [
  {
    name: 'organization',
    id: '1a880fad-2f8e-4343-b95b-29b6fe1d6338',
  },
  {
    name: 'therapist',
    id: '297a343c-2bc0-46a6-8bec-1006903fc777',
  },
  {
    name: 'treatmentIndication',
    id: 'b0aa926f-e8fe-44ae-a615-f04e96e4aa5f',
  },
  {
    name: 'targetGroup',
    id: 'a844474c-80ca-4479-93a3-e590a478fcb4',
  },
  {
    name: 'gender',
    id: 'e8eae1fe-05ce-43d3-a425-497542557d61',
  },
  {
    name: 'ethnicity',
    id: '5f479b80-d04b-4600-8a3e-8e87a1c5c65b',
  },
  {
    name: 'locations',
    id: 'a1da1b6b-e396-4947-a71b-204950ef856d',
  },
  {
    name: 'videoAim',
    id: '3be703de-4864-4e19-9062-b23b3d6b8a43',
  },
  {
    name: 'dialogueEmotion',
    id: '071b1755-23a1-4ae2-93da-47d2fcda81da',
  },
  {
    name: 'furtherNotes',
    id: '3d39e24e-c1c3-4793-80fe-1e3d74173e08',
  },
  {
    name: 'treatmentType',
    id: '1c103fd4-4726-429c-8d86-e5cd8628c751',
  },
  {
    name: 'interactiveSubject',
    id: '16d6ccf9-6246-4842-bbc6-f5f16afa71e4',
  },
  {
    name: 'email',
    id: 'fc335bcf-3024-4f68-acc2-fdaf05351d9f',
  },
];

const generateTaskCustomFields = (formData) =>
  clickUpCustomFields.map((field) => ({
    id: field?.id,
    value: formData[field?.name],
  }));

const createVideoReuest = (formData) => {
  const customFields = generateTaskCustomFields(formData);
  const body = {
    name: `${formData?.therapist} [${formData?.organization}] video request`,
    assignees: [36459600],
    custom_fields: customFields,
    tags: ['form'],
  };

  const locale =
    (i18n.resolvedLanguage || i18n.language || '').split('-')[0] || 'nl';

  return axiosApi.post(
    `/content-request-form/186387025/task?locale=${locale}`,
    body,
  );
};

export const videoRequestService = {
  createVideoReuest,
};
